import React from 'react'
import { LanguageContext } from '../contexts'
import { URLS } from '../http'
import { Workshop } from '../Models/workshops'

interface NoWorkshopEventsAvailableProps {
	workshop: Workshop
}

export const NoWorkshopEventsAvailable = (props: NoWorkshopEventsAvailableProps) => {
	const { localizedText, language } = React.useContext(LanguageContext)

	return (
		<div className='no-workshops-available p-1'>
			<h3 className='title is-4 watermark-text'>
				{props.workshop.WorkshopName[language]}
			</h3>
			<p className='watermark-text'>
				{props.workshop.Description[language]}
			</p>
			<p className='select-prompt watermark-text mt-5'>
				{localizedText.NoWorkshopsAvailableOfThisType} <a href={URLS.LEADERS_LIST} target='_blank'>{localizedText.ContactYourWorkshopLeaderLinkText}</a>.
			</p>
		</div>
	)
}

export default NoWorkshopEventsAvailable